import { Skeleton } from "@mui/material"
import { useTranslation } from "react-i18next"

import { TRADE_TICKET_LOCATORS } from "@/App/Equities/mobile/components/tradeScreen/TradeTicket/locators"
import { Stack } from "@/generated/material"
import { withSubscribe } from "@/utils/withSubscribe"

import { CashValue, PortfolioValue } from "../TradeValues"
import { DetailField } from "./DetailField"

export const BalanceDetails = withSubscribe(
  () => {
    const { t } = useTranslation()

    return (
      <Stack rowGap="md">
        <DetailField label={t("availableBalance")} testId="availableBalance">
          <CashValue />
        </DetailField>
        <DetailField
          label={t("locked")}
          data-testid={TRADE_TICKET_LOCATORS.currentPosition}
          testId="locked"
        >
          <PortfolioValue />
        </DetailField>
      </Stack>
    )
  },
  { fallback: <Skeleton /> },
)
